import { IDeleteFuncionarioAssinaturaUseCase } from "../../../presentation/useCases/delete/delete_funcionario_assinatura_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFuncionarioAssinaturaUseCase
 */

export class DeleteFuncionarioAssinaturaUseCase implements IDeleteFuncionarioAssinaturaUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
  ): Promise<void> {
    await this.repository.deleteFuncionarioAssinatura(idFuncionarioAssinatura);
  }
}